import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import wizardBanner from '@/assets/wizard-banner.jpg';

type SetupLayoutProps = {
  children: ReactNode;
  onSkip?: () => void;
  skipPending?: boolean;
};

/**
 * Split-screen onboarding shell (Figma 347-2807 / 2924 / 2970): ½-width content
 * column on the left, cover image on the right (hidden on small screens). An
 * optional Skip control sits bottom-right inside the content column.
 */
export function SetupLayout({ children, onSkip, skipPending }: SetupLayoutProps) {
  const { t } = useTranslation('setup');

  return (
    <div className="flex min-h-full w-full bg-white">
      <div className="flex w-full flex-col px-6 py-8 md:w-1/2 md:px-16 lg:px-24">
        <div className="mx-auto flex w-full max-w-[534px] flex-1 flex-col justify-center">
          {children}
        </div>
        {onSkip ? (
          <div className="flex justify-end pt-6">
            <button
              type="button"
              onClick={onSkip}
              disabled={skipPending}
              className="text-sm font-medium text-muted-foreground underline transition-colors hover:text-foreground disabled:opacity-50"
            >
              {t('skip')}
            </button>
          </div>
        ) : null}
      </div>
      <div className="hidden bg-[#f3f3f3] md:block md:w-1/2">
        <img src={wizardBanner} alt={t('imageAlt')} className="h-full w-full object-cover" />
      </div>
    </div>
  );
}
